<template>
  <div id="add-topik">
    <form action="#" v-on:submit.prevent="submitForm">
      <div
        class="form-group"
        id="add-topik-modal-select"
        v-if="tipe_project == 1 && is_formed"
      >
        <label for="inputTopik">Grup Topik</label>
        <select
          name="topik"
          id="selectTopik"
          v-model="selected_grup"
          class="form-control"
          style="cursor: pointer"
          required
        >
          <option value="" disabled>Pilih Grup Topik</option>
          <option v-for="(row, index) in group" :key="index" :value="index">
            {{ row.group_name }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <label for="inputTopik">Topik</label>
        <input
          type="text"
          name="topik"
          required
          v-model="topik"
          class="form-control"
          autofocus
          placeholder="Masukkan Topik"
        />
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-primary">Simpan</button>
      </div>
    </form>
    <floating-loader-component v-if="is_loading" />
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
import floating_loader from "@/views/components/floating_loader.vue";

$.pgNotification = notif;
export default {
  name: "modal_edit_topic",
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: {
    "floating-loader-component": floating_loader,
  },
  data() {
    return {
      topik: this.data["topic"],
      id_topic: this.data["id_topic"],
      tipe: this.data["tipe"],
      selected_grup:
        "selected_group" in this.data ? this.data["selected_group"] : "",
      group: "group" in this.data ? this.data["group"] : {},
      is_formed:
        "tipe" in this.data ? (this.data["tipe"] == 2 ? true : false) : false,
      tipe_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.project.project_detail.tipe
          : this.data["tipe_project"],
      callback: "callback" in this.data ? this.data["callback"] : null,
      is_loading: false,
    };
  },
  methods: {
    submitForm: function () {
      if (this.tipe_project == 1) {
        if (this.tipe == 1) {
          this.saveData(null);
        } else {
          this.saveData(this.selected_grup);
        }
      } else {
        this.saveData(null);
      }
    },
    saveData: function (grup) {
      let self = this;
      self.$store.dispatch("loading", true);

      let params = {
        topic: this.$sanitize(this.topik),
        _id: this.id_topic,
        tipe: this.tipe,
        group_id: grup,
      };
      this.is_loading = true;
      let api;
      api = process.env.VUE_APP_API_URL + "new-topic-update";

      let notif_position = "top";
      if ("ref" in this.data) {
        if (this.data["ref"] == "admin") {
          notif_position = "top-right";
        }
      }

      this.$http
        .post(api, params)
        .then(function (response) {
          if (response.status == 200) {
            self.$store.dispatch("loading", false);

            if (self.callback) {
              self.callback();
            } else {
              self.$parent.$parent.getTopic();
            }

            $("#modalSlideUp").modal("hide");
            self.$store.dispatch("loading", false);

            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Topik berhasil diubah!',
                position: notif_position,
                timeout: 5000,
                type: "success",
              })
              .show();
          }
        })
        .catch(function () {
          self.$store.dispatch("loading", false);
          $("#modalSlideUp").modal("hide");

          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan pada saat menambahkan Topik!',
              position: notif_position,
              timeout: 5000,
              type: "danger",
            })
            .show();
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
  },
};
</script>